<template>
  <div class="h-panel">
    <div :class="gridLayout" class="grid-container">
      <h-media-viewer
        :imagePadding="imagePadding"
        :editing="editing"
        class="overflow-visible"
      >
        <div class="three-d-object-frame is-pulled-right">
          <model-viewer
            :src="aws(resource.src)"
            :poster="aws(resource.poster)"
            :ios-src="resource[`ios-src`]"
            :alt="resource.alt"
            shadow-intensity="1"
            auto-rotate
            camera-controls
            autoplay
            @load="mvEvent($event)"
            @error="mvEvent($event)"
            @progress="mvEvent($event)"
          >
            <div slot="progress-bar">
              <b-loading :is-full-page="false" :active.sync="loadingModel" />
            </div>
          </model-viewer>
        </div>
      </h-media-viewer>
      <div class="info-panel" v-show="editing">
        <ValidationObserver ref="observer" v-slot="slots">
          <h-form ref="form" :model="model" :schema="schema" />
          <h-control-dock-edit v-bind="{ ...slots, ...subComponentProps }" />
        </ValidationObserver>
      </div>
      <div class="info-panel" v-show="!editing">
        <h-info-panel
          :model="model"
          :privateType="$attrs.privateType"
          :type="type"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "@google/model-viewer";
import { set, keys, clone } from "lodash";
import { ValidationObserver } from "vee-validate";
import * as ModalElements from "@/components/spaces/index.js";
import schema from "@/assets/schemas/fields/models.schema.js";
import { mixins } from "@/common/mixins.service";
import { showToast } from "@/common/toast.service.js";

export default {
  name: "CommonModelsLayout",
  mixins: [mixins.pinterestLayout],
  components: { ValidationObserver, ...ModalElements.default },
  props: ["editing", "resource"],
  data() {
    return {
      model: undefined,
      schema: schema,
      file: undefined,
      type: `${this.$attrs.privateType ? "t_" : ""}models`,
      loadingModel: false,
    };
  },
  computed: {
    subComponentProps() {
      return {
        type: this.type,
        id: this.resource.id,
      };
    },
  },
  created() {
    this.setInfo(this.resource);
  },
  methods: {
    setInfo(info) {
      const init = clone(info);
      this.model = keys(this.schema).reduce((a, c) => set(a, c, init[c]), init);
    },
    mvEvent(event) {
      //Model is loading if progress is not 1/1. All other events should turn loading to false.
      this.loadingModel =
        event.type === "progress" && event.detail.totalProgress !== 1;

      if (event.type === "error") showToast("Error loading model", "is-danger");
      this.$emit(event.type);
    },
  },
  watch: {
    resource: {
      deep: true,
      handler(val) {
        this.setInfo(val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";
@import "@/assets/scss/pinterestLayout.scss";

.overflow-visible {
  overflow: visible;
}

model-viewer {
  height: 100%;
  width: 100%;
}

.three-d-object-frame {
  height: 500px;
  width: 100%;

  //Either we manipulate the section margins and keep the card square or we resize it like this
  border-radius: $radius-large;
  background: var(--white-ter);
  //   background-image: url("/img/patterns/holos-logo-pattern.png");
  border: 2px var(--navbar-box-shadow-color) solid;
  position: relative;

  > model-viewer {
    border-radius: $radius-large - 1.5pt; // deliberately one pt less than the parent div
    overflow: hidden; // needed for safari
    transform: translateZ(0); // needed for safari
  }
}
</style>
